import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgOrderedList = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M.8 2.825c0-.371.301-.675.675-.675h1.35c.374 0 .675.301.675.675V5.75h.675c.374 0 .675.301.675.675s-.3.675-.675.675h-2.7A.673.673 0 0 1 .8 6.425c0-.374.301-.675.675-.675h.675V3.5h-.675A.673.673 0 0 1 .8 2.825m.855 6.446c.32-.242.712-.371 1.114-.371h.138a1.717 1.717 0 0 1 1.01 3.108l-.676.492h.934c.374 0 .675.301.675.675s-.3.675-.675.675h-2.55a.823.823 0 0 1-.485-1.49l1.983-1.443a.37.37 0 0 0-.216-.667h-.138a.5.5 0 0 0-.304.101l-.585.439a.674.674 0 1 1-.81-1.08zM7.1 2.6h7.2a.899.899 0 1 1 0 1.8H7.1a.899.899 0 1 1 0-1.8m0 4.5h7.2a.899.899 0 1 1 0 1.8H7.1a.899.899 0 1 1 0-1.8m0 4.5h7.2a.899.899 0 1 1 0 1.8H7.1a.899.899 0 1 1 0-1.8"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgOrderedList);
export default ForwardRef;
